import { render, staticRenderFns } from "./CompanyComponent.vue?vue&type=template&id=7188ed2e&scoped=true&"
import script from "./CompanyComponent.vue?vue&type=script&lang=js&"
export * from "./CompanyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7188ed2e",
  null
  
)

export default component.exports